export const DEFAULT_PERKS = [
  'Free coffee',
  'Early stock',
  'Gym',
  'Canteen',
  'Free Beverage',
  'Shower',
  'Free Parking',
  'Free Lunch',
  'In house trainings',
  'Startup Atmosphere',
  'No dress code',
  'Modern office',
];

export const DEFAULT_JOB_TITLES = [
  {
    'job title': 'Network Administrator',
  },
  {
    'job title': 'Senior Software Engineer',
  },
  {
    'job title': 'Network Systems Administrator',
  },
  {
    'job title': 'Software Architect',
  },
  {
    'job title': 'Senior Web Administrator',
  },
];

export const CLOSING_JOB_CHIPS = [
  'Job fulfilled',
  'Hiring freeze',
  'Hire - Backfill',
  'Job on Hold',
  'Not filling',
];

export const REJECT_CANDIDATE_CHIPS = [
  'All positions filled',
  'Less experience',
  'No required skills',
  'High budget expectation',
  'Location inappropriate',
];

export const DEFAULT_LOCATIONS_INDIA = [
  'Bengaluru, India',
  'Hyderabad, India',
  'Pune, India',
  'Chennai, India',
  'Gurgaon, India',
];

export const DEFAULT_LOCATIONS_USA = [
  'Boston, United States',
  'San Jose, United States',
  'Austin, United States',
  'Washington, United States',
  'Seattle, United States',
];

export const IGNORE_VALIDATION_FIELDS = ['histories'];

export const TALENT_STATUS = {
  SOURCE: {
    APPLICANTS: 'applicants',
    LEADS: 'leads',
  },
  applicantsTab: {
    tabLabel: 'Applicants',
    sideBarLinks: [
      { displayLabel: 'Applied', value: 'Applied' },
      { displayLabel: 'Shortlisted', value: 'Shortlisted' },
      { displayLabel: 'Interview', value: 'Interview' },
      { displayLabel: 'Hired', value: 'Hired' },
      { displayLabel: 'Offered', value: 'Offered' },
      { displayLabel: 'Rejected', value: 'Rejected' },
      { displayLabel: 'Favourite', value: 'AppFavourite' },
    ],
    statusTypes: [
      'Shortlisted',
      'Interview',
      'Hired',
      'Offered',
      'Rejected',
      'AppFavourite',
      'Applied',
    ],
    favourite: [
      'Applied',
      'Shortlisted',
      'Interview',
      'Hired',
      'Offered',
      'Rejected',
    ],
  },
  leadsTab: {
    tabLabel: 'Leads',
    sideBarLinks: [
      { displayLabel: 'AllLeads', value: 'Lead' },
      { displayLabel: 'Reached', value: 'Reached' },
      { displayLabel: 'Favourite', value: 'LeadsFavourite' },
      { displayLabel: 'Rejected', value: 'LeadRejected' },
    ],
    statusTypes: ['Lead', 'Reached', 'LeadsFavourite', 'LeadRejected'],
    favourite: ['Lead', 'Reached'],
  },
  favouriteLinks: ['AppFavourite', 'LeadsFavourite', 'TalentConnectFavourite'],
  applied: 'Applied',
  candidates: 'Applied',
  reached: 'Reached',
};

export const NO_CANDIDATE_ERRORS = {
  candidates:
    'Sit Back and Relax! We are constantly reaching out to Talents for this Job.',
  shortlisted: 'No Talent is shortlisted yet.',
  interview: 'No Talent for interview yet.',
  hired: 'No Talent for hire yet.',
  offered: 'No Talent offered yet.',
  rejected: 'No Talent rejected.',
  default: 'No talent found',
};

export const CREATE_JOB_IGNORE_FIELDS = [
  'jobLink',
  'closingDetail',
  'histories',
  'companyLogoUrl',
  'userId',
  'organizationId',
  'currencyValue',
  'lookForSchools',
  'domains',
  'perks',
  'lookForJobRoles',
  'lookForLocations',
  'sharedTo',
  'location',
  'foundedYear',
  'companySize',
  'aboutCompany',
  'currency',
  'maxExperience',
  'minExperience',
  'minSalary',
  'maxSalary',
  'currencyValue',
  'salaryTime',
  'jobDescription',
];

export const JOB_DISPLAY_TYPE = {
  CREATE: 'CREATE_JOB',
  EDIT: 'EDIT_JOB',
};

export const CANDIDATE_LISTING_SORT_OPTIONS = [
  {
    id: 'overallScore',
    value: 'Overall Score',
  },
  {
    id: 'skillMatchScore',
    value: 'Skills relevance',
  },
  {
    id: 'expMatchScore',
    value: 'Experience relevance',
  },
  {
    id: 'titleMatchScore',
    value: 'Job title relevance',
  },
];

export const MONTH_SHORT = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUNE',
  'JULY',
  'AUG',
  'SEPT',
  'OCT',
  'NOV',
  'DEC',
];
